import { StarOutlined } from '@ant-design/icons';
import { CardProps, Space, Tag, Typography } from 'antd';
import { Trans } from 'react-i18next';

import Card from '../../../Card';
import RegistrationEnabledFieldsTags from '../../../components/RegistrationEnabledFieldsTags';
import { RegistrationTemplateDetailSerializer } from '../../../types/api';

interface RegistrationTemplateCardProps extends CardProps {
  registrationTemplate: RegistrationTemplateDetailSerializer;
  standardTemplate?: boolean;
  onEditClick?: () => void;
  alwaysRequiredCpf?: boolean;
}

const RegistrationTemplateCard = ({
  registrationTemplate,
  standardTemplate,
  onEditClick,
  alwaysRequiredCpf,
  ...props
}: RegistrationTemplateCardProps) => {
  return (
    <Card
      title={<Typography.Text strong>{registrationTemplate.name}</Typography.Text>}
      extra={[
        standardTemplate ? (
          <Tag>
            <StarOutlined /> <Trans>Modelo Padrão</Trans>
          </Tag>
        ) : null,
        <Typography.Link key="changeLink" onClick={onEditClick}>
          <Trans>Editar</Trans>
        </Typography.Link>,
      ]}
      {...props}
    >
      <Space direction="vertical">
        <Typography.Text type="secondary">
          <Trans>Campos habilitados:</Trans>
        </Typography.Text>
        <RegistrationEnabledFieldsTags
          fields={registrationTemplate}
          alwaysRequiredCpf={alwaysRequiredCpf}
        />
      </Space>
    </Card>
  );
};

export default RegistrationTemplateCard;
